module.exports = __webpack_public_path__ + "static/media/6.520bb781.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_190/images/九宫格选中态/6.png
// module id = 1632
// module chunks = 0